import { fileExtensionToType, FileTypes } from "../lib/fileExtensionToType";
import { AudioVideoIcon } from "./audio-video-icon";
import { DocIcon } from "./doc-icon";
import { FolderIcon } from "./folder-icon";
import { ImageIcon } from "./image-icon";
import { OtherIcon } from "./other-icon";
import { PdfIcon } from "./pdf-icon";
import { PptIcon } from "./ppt-icon";
import { XlsIcon } from "./xls-icon";
const iconMap = {
  [FileTypes.IMAGE]: ImageIcon,
  [FileTypes.VIDEO]: AudioVideoIcon,
  [FileTypes.AUDIO]: AudioVideoIcon,
  [FileTypes.PDF]: PdfIcon,
  [FileTypes.ARCHIVE]: FolderIcon,
  [FileTypes.WORD]: DocIcon,
  [FileTypes.EXCEL]: XlsIcon,
  [FileTypes.POWERPOINT]: PptIcon,
  [FileTypes.MISC]: OtherIcon
};
const getIcon = (extension) => {
  return iconMap[fileExtensionToType(extension)] ?? OtherIcon;
};
export {
  getIcon
};
//# sourceMappingURL=get-icon.js.map
